import { render, staticRenderFns } from "./BookAppointmentNxt.vue?vue&type=template&id=cf7133fa&"
import script from "./BookAppointmentNxt.vue?vue&type=script&lang=ts&"
export * from "./BookAppointmentNxt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports